
<script>
import { defineComponent } from 'vue'
import Column from '@kit/components/Column.vue'
import "@images/SunriseProtea-Extras_Divider.png" 

export default defineComponent({
  name: "Divider",
  components: {
    Column
  }
});
</script>

<style scoped>
  .img-width {
    width: 250px !important;
  }
</style>

<template>

  <Column tag="div" class="sb sb-h sb-align-ch" gtH="1200" ltD="100" style="margin-bottom:20px;">
    <div class="sb sb-explicit img-width">
      <img style="width:100%; height:auto; object-fit:contain; opacity:0.7;" alt="" src="@images/SunriseProtea-Extras_Divider.png">
    </div>
  </Column>

</template>